<template>
  <div class="confirm-cademic-references">
		<div :class="typeMessage" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>
    <h1>Marcar referencia académica como confirmada</h1>
    <div class="form-group" style="width: 50%">
      <input v-model="academic_reference_local.academic_reference_requested" type="checkbox" class="custom-control-input" id="customSwitch1">
      <label class="custom-control-label" for="customSwitch1">Referencia académica verificada</label>
    </div>
    <div class="form-group">
      <button @click.prevent="update" type="submit" class="btn btn-primary">Guardar</button>
    </div>    
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ConfirmAcademicReferences',
  props: ['academic_reference'],
  data() {
    return {
      message: '',
      typeMessage: '',
    }
  },
  computed: {
    academic_reference_local: {
      get () {
        return this.academic_reference
      },
      set (value) {
        this.$emit('update:academic_reference', value)
      }
    },    
  },
  methods: {
    setCredentials(){
      axios.defaults.headers['x-csrf-token'] = this.token
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    update() {
      this.setCredentials()
      axios.put(`/academic_request/verified?academic_reference_id=${this.academic_reference_local.id}`, { academic_reference_id: this.academic_reference_local.id, academic_reference_requested: this.academic_reference_local.academic_reference_requested }, {}).then(res=>{
        if (res.status == 200) {
          this.showMessage('Confirmación de referencias académicas actualizadas', 'alert-success')
        }
      }, (err) => {
        this.showMessage('No se pudo confirmar la referencias académicas', 'alert-danger')
      })
    },
    showMessage(message, typeMessage){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', 3000)
    },
  },
  created () {
    this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  },
}
</script>

<style scoped>

</style>